import gql from "graphql-tag";

export const getFilters = gql`
  query Filters($businessUnit: String!) {
    entityFilterList(businessUnit: $businessUnit) {
      id
      code
      level
      featured
      fieldAccessor
      description
      inclusive
      order
      withEntity
      withPreposition
      entity {
        code
        dataType
        slug
        label
        icon
      }
      filters {
        id
        label
        slug
        order
        code
        description
        sortable
        operator
        value
        preFilter
      }
    }
  }
`;
